export interface CheckboxFilterInterface {
  group: string;
  name: string;
  value: string | number;
}
